import React from "react";
import Routes from "./Routes";

// Context
import { ProvideAuth } from "./context/useAuth";
import { ProvideVisibility } from "./context/useVisibility";
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { DevErrorBoundary } from "@tw/tw-common-js";

function App() {
  return (
    <DevErrorBoundary>
      <div className="main-container">
        <BrowserRouter>
          <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
            <ProvideVisibility>
              <ProvideAuth>
                <Routes />
              </ProvideAuth>
            </ProvideVisibility>
          </GoogleOAuthProvider>
        </BrowserRouter>
      </div>
    </DevErrorBoundary>
  );
}

export default App;
